var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNotificationsIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 24 24",
    fill: "current",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 24c1.326 0 2.402-1.076 2.402-2.402h-4.804C9.598 22.924 10.674 24 12 24zM18.707 16.293C18.316 15.902 18 15.385 18 14.828V10c0-3.309-2.239-6.091-5.25-6.837V2.5c0-.828-.671-1.5-1.5-1.5S9.75 1.672 9.75 2.5v.663C6.739 3.909 4.5 6.691 4.5 10v4.828c0 .557-.316 1.074-.707 1.465-.391.391-.793.844-.793 1.379 0 .828.672 1.5 1.5 1.5h13.5c.828 0 1.5-.672 1.5-1.5 0-.535-.402-.988-.793-1.379z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationsIcon);
export default __webpack_public_path__ + "static/media/NotificationsIcon.018a3df17b212d45f6f2fd9281fa1304.svg";
export { ForwardRef as ReactComponent };